import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PostedFlightFacade } from '../+state/posted-flight/posted-flight.facade';

@Component({
  selector: 'sd-portal-posted-flight-audit',
  templateUrl: './posted-flight.component.html',
  styleUrls: ['./posted-flight.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostedFlightComponent implements OnInit {
  constructor(readonly postedFlightFacade: PostedFlightFacade) {}

  ngOnInit() {
    this.postedFlightFacade.loadPostedFlight();
  }
}
